// export const BACKEND_BASE = "https://us-east-1.aws.data.mongodb-api.com/app/application-0-xinyfjf/endpoint";
export const BACKEND_BASE = "https://admin.riameets.com";
